import React from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { StoreInfo } from "../types";

interface LayoutProps {
  storeInfo: StoreInfo;
}

export const Layout: React.FC<LayoutProps> = ({ storeInfo }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header storeInfo={storeInfo} />

      <main className="flex-1">
        <Outlet />
      </main>

      <Footer storeInfo={storeInfo} />
    </div>
  );
};

export default Layout;
